export enum FormDesignerControlCode {
    Section = "section",
    Input = "input",
    Select = "select",
    Check = "check",
    Radio = "radio",
    Date = "date",
    Time = "time",
    DateTime = "datetime",
    Table = "table",
    File = "file",
}